import React from 'react';
import OrderList from './OrderList';

export const WROrderList = props => (<OrderList {...props} />);
